export default __webpack_public_path__ + "static/media/uat.38db5bdb.svg";